import { render } from "./OmnichannelProfileCard.vue?vue&type=template&id=0f56624f&scoped=true"
import script from "./OmnichannelProfileCard.vue?vue&type=script&lang=js"
export * from "./OmnichannelProfileCard.vue?vue&type=script&lang=js"

import "./OmnichannelProfileCard.vue?vue&type=style&index=0&id=0f56624f&lang=scss&scoped=true"
import "./OmnichannelProfileCard.vue?vue&type=style&index=1&id=0f56624f&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f56624f"]])

export default __exports__